<template>
  <div id="dvApplicationPrint" width="97%" height="90%" style="padding-bottom: 10px">
    <div
      class="Flex_Table tblEntryForm"
      style="padding-right: 5px"
      v-bind:class="
      lstPrintTicket.isPaymentDone != 1
        ? 'page RedBorder'
        : 'page GreenBorder'
    "
    >
      <div class="Flex_Row" align="center">
        <div class="Flex_Cell">
          <button
            v-on:click="showTicket()"
            title="Click Here to Print"
            style="
                  padding-top: 5px;
                  padding-bottom: 5px;
                  padding-left: 20px;
                  padding-right: 20px;
                "
            type="button"
          >
            <i class="glyphicons print"></i> PRINT
          </button>
        </div>
      </div>
      <div class="Flex_Row" align="center">
        <div class="Flex_Cell">
          <img src="../assets/images/logoa.png" class="imgHeight" />
        </div>
      </div>
      <!-- <div class="Flex_Row" align="center">
        <div class="Flex_Cell">
          <span style="color: #054889; font-size: 22px"
            ><b>{{ this.lstPrintTicket.placeToVisit }}</b></span
          >
        </div>
      </div>-->
      <div class="Flex_Row" align="center">
        <div class="Flex_Cell" style="color: #054889">
          <span style="font-size: 18px">
            <b>Booking Ticket For :</b>
          </span>
          <span style="font-size: 18px">
            {{
            this.lstPrintTicket.placeToVisit
            }}
          </span>
        </div>
      </div>
      <div class="Flex_Row">
        <div class="Flex_Cell" valign="middle" style="width: 35%" align="center">
          <div id="divQRCodeData">
            <img
              v-if="lstPrintTicket.qrCode != null"
              id="imgQRCode"
              style="width: 210px; height: 210px"
              :src="'data:image/jpeg;base64,' + lstPrintTicket.qrCode"
            />
          </div>
        </div>
        <div class="Flex_Cell" style="width: 65%">
          <div class="Flex_Table" style="padding-top: 20px">
            <div class="Flex_Row tblRow">
              <div class="Flex_Cell" width="40%">
                <b>Booking Type</b>
              </div>
              <div class="Flex_Cell" width="5%">
                <b>:</b>
              </div>
              <div class="Flex_Cell" width="55%">{{ this.lstPrintTicket.bookingTypeName }}</div>
            </div>
            <div class="Flex_Row tblRow">
              <div class="Flex_Cell" width="40%">
                <b>Ticket No.</b>
              </div>
              <div class="Flex_Cell" width="5%">
                <b>:</b>
              </div>
              <div class="Flex_Cell" width="55%">{{ this.lstPrintTicket.ticketNo }}</div>
            </div>
            <div class="Flex_Row tblRow">
              <div class="Flex_Cell" width="40%">
                <b>Reference No.</b>
              </div>
              <div class="Flex_Cell" width="5%">
                <b>:</b>
              </div>
              <div class="Flex_Cell" width="55%">{{ this.lstPrintTicket.refNo }}</div>
            </div>
            <div class="Flex_Row tblRow" v-if="this.lstPrintTicket.slotDetails != ''">
              <div class="Flex_Cell" width="40%">
                <b>Slot Details</b>
              </div>
              <div class="Flex_Cell" width="5%">
                <b>:</b>
              </div>
              <div class="Flex_Cell" width="55%">{{ this.lstPrintTicket.slotDetails }}</div>
            </div>
            <div class="Flex_Row tblRow">
              <div class="Flex_Cell" width="40%">
                <b>Booking Date</b>
              </div>
              <div class="Flex_Cell" width="5%">
                <b>:</b>
              </div>
              <div class="Flex_Cell" width="55%">{{ this.lstPrintTicket.bookingdates }}</div>
            </div>
            <div class="Flex_Row tblRow">
              <div class="Flex_Cell" width="40%">
                <span v-if="this.lstPrintTicket.isForGroup == 1">
                  <b>No. Of Groups</b>
                </span>
                <span v-else>
                  <b>No. Of Individuals</b>
                </span>
              </div>
              <div class="Flex_Cell" width="5%">
                <b>:</b>
              </div>
              <div class="Flex_Cell" width="55%">{{ this.lstPrintTicket.totalNoOfIndividuals }}</div>
            </div>
            <div class="Flex_Row tblRow">
              <div class="Flex_Cell" width="40%">
                <b>Amount</b>
              </div>
              <div class="Flex_Cell" width="5%">
                <b>:</b>
              </div>
              <div class="Flex_Cell" width="55%">
                Rs.
                <span>{{ this.lstPrintTicket.amount }}</span>
              </div>
            </div>
            <div class="Flex_Row tblRow" v-if="lstPrintTicket.cgst > 0">
              <div class="Flex_Cell" width="40%">
                <b>CGST</b>
              </div>
              <div class="Flex_Cell" width="5%">
                <b>:</b>
              </div>
              <div class="Flex_Cell" width="55%">{{ this.lstPrintTicket.cgst }}</div>
            </div>
            <div class="Flex_Row tblRow" v-if="lstPrintTicket.sgst > 0">
              <div class="Flex_Cell" width="40%">
                <b>SGST</b>
              </div>
              <div class="Flex_Cell" width="5%">
                <b>:</b>
              </div>
              <div class="Flex_Cell" width="55%">{{ this.lstPrintTicket.sgst }}</div>
            </div>
            <div class="Flex_Row tblRow" v-if="lstPrintTicket.sgst > 0">
              <div class="Flex_Cell" width="40%">
                <b>Other Tax</b>
              </div>
              <div class="Flex_Cell" width="5%">
                <b>:</b>
              </div>
              <div class="Flex_Cell" width="55%">{{ this.lstPrintTicket.otherTax }}</div>
            </div>
            <div class="Flex_Row tblRow" v-if="lstPrintTicket.discountAmount > 0">
              <div class="Flex_Cell" width="40%">
                <b>Discount Amount</b>
              </div>
              <div class="Flex_Cell" width="5%">
                <b>:</b>
              </div>
              <div class="Flex_Cell" width="55%">{{ this.lstPrintTicket.discountAmount }}</div>
            </div>
            <div class="Flex_Row tblRow" v-if="lstPrintTicket.discountAmount > 0">
              <div class="Flex_Cell" width="40%">
                <b>Promo Code</b>
              </div>
              <div class="Flex_Cell" width="5%">
                <b>:</b>
              </div>
              <div class="Flex_Cell" width="55%">{{ this.lstPrintTicket.promoCode }}</div>
            </div>
            <div class="Flex_Row tblRow">
              <div class="Flex_Cell" width="40%">
                <b>Total Amount</b>
              </div>
              <div class="Flex_Cell" width="5%">
                <b>:</b>
              </div>
              <div class="Flex_Cell" width="55%">Rs. {{ this.lstPrintTicket.totalAmount }}</div>
            </div>
            <div class="Flex_Row tblRow">
              <div class="Flex_Cell" width="40%">
                <b>Payment Status</b>
              </div>
              <div class="Flex_Cell" width="5%">
                <b>:</b>
              </div>
              <div class="Flex_Cell" width="55%">
                <span
                  v-if="this.lstPrintTicket.isPaymentDone != 1"
                  style="color: RED; font-weight: bold"
                >
                  {{
                  this.lstPrintTicket.paymentStatus }}
                </span>
                <span
                  v-if="this.lstPrintTicket.isPaymentDone == 1"
                  style="color: GREEN; font-weight: bold"
                >
                  {{
                  this.lstPrintTicket.paymentStatus }}
                </span>
              </div>
            </div>
            <div class="Flex_Row tblRow">
              <div class="Flex_Cell" width="40%">
                <b>Ticket Status</b>
              </div>
              <div class="Flex_Cell" width="5%">
                <b>:</b>
              </div>
              <div class="Flex_Cell" width="55%">
                <span
                  v-if="this.lstPrintTicket.isPaymentRefunded == 0"
                  style="color: green; font-weight: bold"
                >Ticket Booked</span>
                <span
                  v-if="this.lstPrintTicket.isPaymentRefunded == 2"
                  style="color: Orange; font-weight: bold"
                >Refund Initiated</span>
                <span
                  v-if="this.lstPrintTicket.isPaymentRefunded == 1"
                  style="color: Green; font-weight: bold"
                >Amount Refunded</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="Flex_Row tblRow"
        style="padding-top: 10px"
        v-if="lstPrintTicketReceipt.length > 0"
      >
        <div class="Flex_Cell" valign="middle" style="width: 25%">
          <b>Payment Mode :</b>
        </div>
        <div
          class="Flex_Cell"
          valign="middle"
          style="width: 25%"
        >{{ this.lstPrintTicketReceipt[0].paymentMode }}</div>
        <div class="Flex_Cell" valign="middle" style="width: 25%">
          <b>Transaction Id :</b>
        </div>
        <div
          class="Flex_Cell"
          valign="middle"
          style="width: 25%"
        >{{ this.lstPrintTicketReceipt[0].transactionID }}</div>
      </div>
      <div class="Flex_Row tblRow" v-if="lstPrintTicketReceipt.length > 0">
        <div class="Flex_Cell" valign="middle" style="width: 25%">
          <b>Transaction Date :</b>
        </div>
        <div
          class="Flex_Cell"
          valign="middle"
          style="width: 25%"
        >{{ this.lstPrintTicketReceipt[0].transCompleteDate }}</div>
        <div class="Flex_Cell" valign="middle" style="width: 25%">
          <b>Transaction Amount :</b>
        </div>
        <div
          class="Flex_Cell"
          valign="middle"
          style="width: 25%"
        >Rs. {{ this.lstPrintTicketReceipt[0].paymentAmount }}</div>
      </div>
      <div class="Flex_Row tblRow" v-if="lstPrintTicketReceipt.length > 0">
        <div class="Flex_Cell" valign="middle" style="width: 25%">
          <b>Receipt No. :</b>
        </div>
        <div
          class="Flex_Cell"
          valign="middle"
          style="width: 25%"
        >{{ this.lstPrintTicketReceipt[0].receiptNo }}</div>
        <div class="Flex_Cell" valign="middle" style="width: 25%"></div>
        <div class="Flex_Cell" valign="middle" style="width: 25%"></div>
      </div>
      <div class="Flex_Row wrap" style="padding: 10px" v-if="lstPrintTicketReceipt.length > 0">
        <b>Note</b> : &nbsp;
        <li>
          This receipt does not include any charges towards online transaction /
          convenience fee levied by payment gateway.
        </li>
      </div>
      <div class="Flex_Row" style="padding: 10px">
        <div class="Flex_Table ekkGrid" style="border-radius: 6px">
          <div class="Flex_Row GridHeader" valign="middle" align="center" style="min-height: 40px">
            <div class="Flex_Cell" style="width: 25%">Category</div>
            <div class="Flex_Cell" style="width: 25%">Total No. of Person(s)</div>
            <div class="Flex_Cell" style="width: 25%">Rate</div>
            <div class="Flex_Cell" style="width: 25%">Amount (in Rs.)</div>
          </div>
          <div
            class="Flex_Row"
            v-for="(row, index) in lstPrintTicket.printTicketDetails"
            :key="index"
            style="min-height: 30px"
          >
            <div
              class="Flex_Cell"
              style="width: 25%"
              valign="middle"
              align="center"
            >{{ row.personAgeGroupName }}</div>
            <div
              class="Flex_Cell"
              style="width: 25%"
              valign="middle"
              align="center"
            >{{ row.totalNoOfPersons }}</div>
            <div
              class="Flex_Cell"
              style="width: 25%"
              valign="middle"
              align="center"
            >Rs. {{ row.individualRate }}</div>
            <div
              class="Flex_Cell"
              style="width: 25%"
              valign="middle"
              align="center"
            >Rs. {{ row.amountInRs }}</div>
          </div>
        </div>
      </div>
      <div class="Flex_Row" style="padding: 10px" v-if="lstPrintTicket.printTicketVisitors">
        <div class="Flex_Table ekkGrid" style="border-radius: 6px">
          <div class="Flex_Row GridHeader" valign="middle" align="center" style="min-height: 40px">
            <div class="Flex_Cell" style="width: 34%">Name</div>
            <div class="Flex_Cell" style="width: 33%">Gender</div>
            <div class="Flex_Cell" style="width: 33%">Date of Birth</div>
            <!-- <div class="Flex_Cell">ID</div>
            <div class="Flex_Cell">Contact Detail</div>-->
          </div>
          <div
            class="Flex_Row"
            v-for="(row, index) in lstPrintTicket.printTicketVisitors"
            :key="index"
            style="min-height: 30px"
          >
            <div class="Flex_Cell wrapText" style="width: 34%" valign="middle" align="center">
              {{ row.titleName }} {{ row.firstName }} {{ row.middleName }}
              {{ row.lastName }}
            </div>
            <div class="Flex_Cell wrapText" style="width: 33%" valign="middle" align="center">
              <span>{{ row.genderName }}</span>
            </div>
            <div class="Flex_Cell wrapText" style="width: 33%" valign="middle" align="center">
              <span>{{ row.dob }}</span>
            </div>
            <div
              class="Flex_Cell wrapText"
              v-if="row.idTypeName != '' || row.idNumber != ''"
              valign="middle"
              align="center"
            >
              <span>
                {{ row.idTypeName }}
                <br />
                {{ row.idNumber }}
              </span>
            </div>
            <div
              class="Flex_Cell wrapText"
              valign="middle"
              v-if="row.email != '' || row.mobile != ''"
              align="center"
            >
              {{ row.email }}
              <br />
              {{ row.mobile }}
            </div>
          </div>
        </div>
      </div>
      <div class="Flex_Row wrap" style="padding: 10px">
        <b>Note</b> : &nbsp;
        <li>
          BRO will not be liable for any kind of losses, damages or injury to
          anyone.
        </li>
      </div>
    </div>
  </div>
</template>
<script>
import vue from "vue";
import axios from "axios";
import Router from "vue-router";
import config from "@/router/globalConfig";
import AcceptInput from "./ekkControls/AcceptInput";
import DateControl from "./ekkControls/DateControl";
import Report from "@/router/Report";
import { jsPDF } from "jspdf";
export default {
  name: "PrintTicket",
  components: {
    AcceptInput: AcceptInput,
    DateControl: DateControl
  },
  props: {
    TicketNo: { type: String, required: true },
    eventBus: { type: Object },
    eventMount: { type: Object }
  },
  data() {
    return {
      ticketNo: "",
      lstPrintTicket: [],
      lstPrintTicketReceipt: [],
      IsShow: false,
      BookingID: -1,
      fromDate: new Date(),
      toDate: new Date(),
      noOfUnits: 0
    };
  },
  methods: {
    showTicket() {
      //alert('this.TicketNo : ' + this.TicketNo)
      const basicData = {
        FileName: "Ticket",
        FileFormat: "PDF",
        FileExtension: "pdf",
        Param1: "Ticket",
        Param2: "",
        BookingID: this.BookingID,
        TicketNo: this.TicketNo,
        type: 1
      };
      var formData = new FormData();
      formData.append("BasicFormData", JSON.stringify(basicData));
      axios
        .post(config.WEB_API_PATH + "MyBooking/ShowPrintTicket", formData, {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token
          },
          crossdomain: true
        })
        .then(
          response => {
            // console.log(response.data.result);
            var msg = Report.showReport(response.data.result, false);
            if (msg == false) {
              MessageBox.show({
                message: "No Record Found",
                type: "error",
                title: "Error"
              });
            }
          },
          error => {}
        );
      // axios
      //   .get(config.WEB_API_PATH + "ScanTicket/ShowPrintTicket", {
      //     headers: {
      //       __RequestVerificationToken: config.AF_Token,
      //       Authorization: config.LOG_Token,
      //     },
      //     params: _data_,
      //     crossdomain: true,
      //   })
      //   .then(
      //     (response) => {
      //       if (response.data.length > 0) {
      //       } else {
      //         //this.ClearPrintTicket();
      //         alert("Not Found!");
      //       }
      //     },
      //     (error) => {}
      //   );
    },
    PrintTicket() {
      this.lstPrintTicket = [];
      //alert("this.TicketNo : " + this.TicketNo);
      const _data_ = {
        BookingID: this.BookingID,
        TicketNo: this.TicketNo,
        FormID: -1,
        type: 1
      };
      axios
        .get(config.WEB_API_PATH + "MyBooking/GetPrintTicket", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token
          },
          params: _data_,
          crossdomain: true
        })
        .then(
          response => {
            console.log(response.data);
            if (response.data.length > 0) {
              if (this.lstPrintTicket.bookingID != 0) {
                this.lstPrintTicket = response.data[0];
                this.noOfUnits = this.lstPrintTicket.printTicketDetails[0].noOfUnits;
                if (this.lstPrintTicket.printTicketReciept.length) {
                  this.lstPrintTicketReceipt = this.lstPrintTicket.printTicketReciept;
                }
                this.IsShow = true;
              }
            } else {
              //this.ClearPrintTicket();
              alert("Not Found!");
            }
          },
          error => {}
        );
    },
    // ClearPrintTicket() {
    //   this.printpdf();
    //   //this.lstPrintTicket = [];
    //   //this.IsShow = false;
    //   //this.TicketNo = "";

    // },
    onQRScannerClick() {
      let self = this;
      biometric.ekkScanQR(function(responce) {
        //console.log(responce);
        if (responce.data.IsVerified == "1") {
          var candID = responce.data.retString;
          this.BookingID = responce.data.retString;
          if (candID != "" && candID != -1) {
            self.getCandidateData(candID, 1);
            this.PrintTicket();
          }
        } else {
          MessageBox.show({
            message: responce.data.retString,
            type: "info",
            title: "API says"
          });
        }
      });
    },

    printpdf() {
      let me = this;
      let source = window.document.getElementById("dvApplicationPrint")
        .innerHTML;
      let doc = new jsPDF("p", "pt", "a4");
      //let doc = new jsPDF("p", "pt", [612,792]);
      let str = "";

      doc.html(source, {
        callback: function(pdf) {
          pdf.save(me.TicketNo + ".pdf");
        }
      });
    }
  },
  computed: {},
  mounted() {
    if (this.eventBus) {
      let _printPDF = this.printpdf;
      let _PrintTicket = this.PrintTicket;
      this.eventBus.$on("printPDF", function() {
        _printPDF();
      });
      this.eventBus.$on("PrintTicket", function() {
        _PrintTicket();
      });
    }
  },
  watch: {}
};
</script>
<style scoped>
.tblRow {
  border-bottom: solid 1px darkgray;
  padding-top: 3px;
  padding-bottom: 3px;
}

/* #tblPrint {
  background: url("../assets/images/AOC_Logo.png");
  background-repeat: no-repeat;
  align-items: center;
} */
.myhead::-webkit-scrollbar {
  background-color: transparent;
}

.myhead::scrollbar {
  background-color: transparent;
}

.mandatorySpan {
  text-align: left;
  position: relative;
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.mandatorySpan.Required:after {
  color: red;
  content: "*";
  position: absolute;
  height: 8px;
  top: -5px;
  font-size: 200%;
}

#divSummary {
  margin-left: 4px;
  margin-right: 5px;
  /* border: dotted 1px darkgray;
        border-radius: 5px;
        padding: 5px 0px 0px 5px; */
}

.ekkGrid > .Flex_Row:hover:not(.GridHeader),
.ekkGrid > .GridContent > .Flex_Row:hover:not(.GridHeader) {
  background-color: #ffa50069;
  color: black;
}

.RedBorder {
  padding: 10px;
  margin: 10px;
  border: solid 3px red;
}

.GreenBorder {
  padding: 10px;
  margin: 10px;
  border: solid 3px green;
}
.fade-enter-active {
  animation: fade-in 0.4s;
}

.fade-leave-active {
  animation: fade-in 0.4s reverse;
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }

  5% {
    opacity: 0.05;
  }

  10% {
    opacity: 0.1;
  }

  20% {
    opacity: 0.2;
  }

  25% {
    opacity: 0.25;
  }

  30% {
    opacity: 0.3;
  }

  35% {
    opacity: 0.35;
  }

  40% {
    opacity: 0.4;
  }

  45% {
    opacity: 0.45;
  }

  50% {
    opacity: 0.5;
  }

  55% {
    opacity: 0.55;
  }

  60% {
    opacity: 0.6;
  }

  65% {
    opacity: 0.65;
  }

  70% {
    opacity: 0.7;
  }

  75% {
    opacity: 0.75;
  }

  80% {
    opacity: 0.8;
  }

  85% {
    opacity: 0.85;
  }

  90% {
    opacity: 0.9;
  }

  95% {
    opacity: 0.95;
  }

  100% {
    opacity: 1;
  }
}
.wrapText {
  overflow-wrap: anywhere;
}

.backgroundPopup {
  position: fixed;
  _position: absolute;
  /* hack for internet explorer 6*/
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: #000000;
  border: 1px solid #cecece;
  z-index: 1;
  opacity: 0.5;
}

.PopUpCover {
  border: solid 1px;
  border-radius: 4px;
  top: 110px;
  position: absolute;
  min-height: 256px;
  right: 380px;
  /* background-color: ;rgba(255, 248, 248, 0.86); */
  background-color: ghostwhite;
  -webkit-box-shadow: 1px 1px 20px 1px white;
  box-shadow: 1px 1px 20px 1px white;
  border-radius: 8px 8px 8px 8px;
  z-index: 2;
  color: black !important;
  width: 600px;
}

.PopUpDetail {
  padding: 10px;
  /* min-height: 200px;
        max-height: 400px; */
  overflow: auto;
}

.PopUpHeader {
  padding: 5px !important;
  font-size: 13pt;
  min-height: 38px;
  border-bottom: solid 1px;
  border-radius: 8px;
}

.PopClose {
  line-height: 18px;
  right: 2px;
  top: 3px;
  position: absolute;
  color: white;
  font-weight: 700;
  display: block;
  padding: 5px;
  background-color: rgba(255, 0, 0, 0.94);
  border-radius: 6px;
  cursor: pointer;
  width: 28px;
  text-align: center;
}

.popbounce-enter-active {
  animation: popbounce-in 0.5s;
}

.popbounce-leave-active {
  animation: popbounce-in 0.4s reverse;
}

.tabClass {
  padding: 5px 8px;
  margin-right: 3px;
  font-size: medium;
  border: solid 1px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  font-family: consolas;
  cursor: pointer;
  border-right: solid 2px black;
  /* box-shadow: 3px 1px 4px; */
  background-color: white;
  color: Black;
}

.tabSelectClass {
  padding: 5px 8px;
  margin-right: 3px;

  background-color: rgb(1, 164, 246) !important;
  font-weight: bold;
  font-family: consolas;
  font-size: medium;
  border: solid 1px black;
  border-right: solid 2px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  border-right: solid 2px black;
  /* box-shadow: 3px 1px 4px black; */
  border-bottom: solid 2px black;
  cursor: pointer;
  color: white;
}

.page {
  width: 100%;
  padding: 10px;
  margin: 10px;
  /* border: solid 1px black; */
}

.TableGrid {
  table-layout: fixed;
}

.TableGrid tr:first-child td {
  font-weight: bold;
}

.TableGrid td {
  border-top: 0.01em solid darkgray;
  border-right: 0.01em solid darkgray;
  word-wrap: break-word;
  letter-spacing: 0.5px;
}

@keyframes popbounce-in {
  0% {
    transform: scale(0);
  }

  25% {
    transform: scale(0.25);
  }

  50% {
    transform: scale(0.5);
  }

  75% {
    transform: scale(0.75);
  }

  100% {
    transform: scale(1);
  }
}
@media screen and (max-width: 800px) {
  .imgHeight {
  }

  .EntryBlock {
    width: 80%;
  }

  #divApplication {
    display: block;
    height: auto;
  }

  #location {
    width: 70%;
  }

  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }

  .EntryBlock {
    width: 100%;
  }

  fieldset > div {
    width: calc(100vw - 15px);
    overflow: auto;
  }

  .tblEntryForm {
    width: calc(100vw - 35px);
  }

  /* width 15px less*/
  .tblEntryForm .Flex_Row {
    display: flex;
    flex-wrap: wrap;
  }

  /* this is responsible for cell wraping*/
  .tblEntryForm .Flex_Row > .Flex_Cell {
    width: 50% !important;
  }

  /* width of any cell time of screen sizing*/
  .tblEntryForm .Flex_Row > .Flex_Cell_Inline {
    width: 50% !important;
    line-height: 36px;
  }

  /* width of any cell time of screen sizing*/
  /* Auto calculate the height of the grid div for scrolling when screen size change*/
  .Location {
    max-width: calc(100vw - 30px) !important;
    width: calc(100vw - 40px) !important;
  }

  /*Overflow for horizontal */
  .ekkGrid .GridContent {
    overflow: unset;
  }

  /*then only horizontal scrolling works */
  .Flex_Table.ekkGrid .Flex_Row {
    width: 100%;
  }
}

@media screen and (max-width: 480px) {
  .imgHeight {
    height: 60px;
  }

  .EntryBlock {
    width: calc(100vw - 35px);
  }

  fieldset > div {
    width: calc(100vw - 35px);
    overflow: auto;
  }

  #location {
    width: 70%;
  }

  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }

  .tblEntryForm > .Flex_Row > .Flex_Cell {
    width: 100% !important;
  }

  .tblEntryForm > .Flex_Row > .Flex_Cell_Inline {
    width: 100% !important;
    line-height: 36px;
  }

  .tblEntryForm .divHR {
    display: block;
  }

  .Flex_Table.ekkGrid.Location {
    max-width: calc(100vw - 40px) !important;
    width: calc(100vw - 40px) !important;
  }

  legend {
    width: calc(100vw - 40px) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PrintTicket.vue